import type { TFunction } from 'i18next';

const COMPENSATION_NAME_I18N_KEYS: Record<string, string> = {
  'Base Salary': 'pe.db.comp.Base Salary',
  'Total Cash': 'pe.db.comp.Total cash',
  'Total Direct Comp': 'pe.db.comp.Total Direct Comp',
  'Variable Pay': 'pe.variablePay',
  '12 months total STI/bonus paid': 'pe.settings.rti.field.twelveMonthTotalStiBonusPaid',
  '12 months total LTI paid': 'pe.settings.rti.field.twelveMonthTotalLtiPaid',
};

const DEMOGRAPHIC_NAME_I18N_KEYS: Record<string, string> = {
  Gender: 'pe.db.demo.Gender',
  Race: 'pe.race',
};

const CUSTOM_COMPENSATION_FIELD_REGEX = /^Custom Compensation Field (\d+)$/;

export function getCompensationName(
  name: string | undefined | null,
  t: TFunction,
): string {
  if (!name) return '';

  const customMatch = CUSTOM_COMPENSATION_FIELD_REGEX.exec(name);
  if (customMatch) {
    return t('pe.settings.rti.field.customCompField', {
      number: customMatch[1],
      defaultValue: name,
    });
  }

  const mappedKey = COMPENSATION_NAME_I18N_KEYS[name];
  if (mappedKey) {
    return t(mappedKey, { defaultValue: name });
  }

  return t(`pe.db.comp.${name}`, { defaultValue: name });
}

export function getCompensationDescription(
  name: string | undefined | null,
  fallbackDescription: string | undefined | null,
  t: TFunction,
): string {
  const fallback = fallbackDescription ?? '';
  if (!name) return fallback;

  const customMatch = CUSTOM_COMPENSATION_FIELD_REGEX.exec(name);
  if (customMatch) {
    return t('pe.db.comp.desc.Custom Compensation Field', {
      number: customMatch[1],
      defaultValue: fallback,
    });
  }

  return t(`pe.db.comp.desc.${name}`, { defaultValue: fallback });
}

export function getDemographicName(
  name: string | undefined | null,
  t: TFunction,
): string {
  if (!name) return '';

  const mappedKey = DEMOGRAPHIC_NAME_I18N_KEYS[name];
  if (mappedKey) {
    return t(mappedKey, { defaultValue: name });
  }

  return t(`pe.db.demo.${name}`, { defaultValue: name });
}
